import { render, staticRenderFns } from "./PWmatUpdateFuncDCU.vue?vue&type=template&id=57adf9ec&scoped=true&"
import script from "./PWmatUpdateFuncDCU.vue?vue&type=script&lang=js&"
export * from "./PWmatUpdateFuncDCU.vue?vue&type=script&lang=js&"
import style0 from "./PWmatUpdateFuncDCU.vue?vue&type=style&index=0&id=57adf9ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57adf9ec",
  null
  
)

export default component.exports